import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Guard from 'components/Guard'
import Redirect from 'components/Redirect'
import Login from 'sections/auth/Login'
import Radar from 'sections/Radar'

const Ro = () => {

  return <BrowserRouter>
    <Routes>
      <Route path="/" Component={ Guard }>

        <Route path="radar" Component={ Radar } />

        <Route
          index
          element={ <Redirect to="/radar" /> }
        />

        <Route
          path="*"
          element={ <Redirect to="/radar" /> }
        />
      </Route>

      <Route path="/auth/login" Component={ Login } />
    </Routes>
  </BrowserRouter>
}

export default Ro
